import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractSelect from '../abstract-select/abstract-select';
import BPCListQueryConfig from '@core/interfaces/bpc-list-query-config';
import { get } from 'lodash';
import { offset } from '@popperjs/core';

@Component({
  name: 'bpc-entity-tabs',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class EntityTabs extends mixins(AbstractField, AbstractSelect) {
  $refs!: {
    provider: InstanceType<typeof EntityTableProvider> & {
      getEntities(): void;
      loading: boolean;
      items: any[];
      pagination: any;
      queryConfig: BPCListQueryConfig;
    };
    load: any;
  };

  @Prop({
    type: Boolean,
    default: true,
  })
  readonly withAll: boolean;

  @Prop(Array) readonly filters: any[];

  @Prop({ type: Boolean, default: false }) readonly ignoreURLParamsForTabs: boolean;
  @Prop({ type: Boolean, default: false }) readonly useDefault: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly withNew: boolean;

  @Prop({ type: Array, default: null }) readonly selectConfigName: string[];

  public tabOptions = [];

  constructor() {
    super();
  }

  public getOptions() {
    if (this.$refs.provider) {
      this.tabOptions = this.$refs.provider.items;
      return this.tabOptions;
    }
  }

  onClick(tab) {
    const offset = this.withAll ? 1 : 0;
    if (tab || !this.withAll) {
      if (this.tabOptions[tab - offset]) {
        this.model = this.tabOptions[tab - offset][this.selectValue];
      } else {
        this.model = 'new';
      }
    } else {
      this.model = null;
    }
  }

  get defaultActive(): boolean {
    return this.tabOptions.some(item => item.default == true);
  }

  onLoadItems() {
    console.log('onLoadItems');
    this.tabOptions = this.$refs.provider.items;
    if (!this.model && this.defaultActive && this.useDefault) {
      this.model = this.tabOptions.find(item => item.default == true)[this.selectValue];
    }
    this.$nextTick().then(() => {
      this.$root.$emit(`${this.selectEntity}-tabs-loaded`);
    });
  }

  extendHandleEvent(eventName: string, event: any, val: any) {
    if (event.filters) {
      event.filters.forEach(filter => {
        if (filter.strictValue) {
          this.$set(this.$refs.provider.queryConfig.params, filter.field, filter.value);
        } else {
          this.$set(this.$refs.provider.queryConfig.params, filter.field, get(val, filter.value));
        }
      });
    }
    if (event.action === 'getEntities') {
      this.$refs.provider.items = [];
      this.model = null;
      this.$refs.provider.getEntities();
    }
  }
}
